module.exports = __webpack_public_path__ + "img/20200418112847932.0a5f00cb.png";